class inViewport {
    isInViewport(elem) {
      var distance = elem.getBoundingClientRect();
      return (
        distance.top >= 0 &&
        distance.left >= 0 &&
        distance.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        distance.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    }
  
    checkInView(findMe) {
      var obj = this;
      findMe.forEach(function(el) {
        if (obj.isInViewport(el)) {
          el.classList.add("inview");
        }
      });
    }
  }
  
  export default inViewport;
  